// src/redux/slices/authSlice.js
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { ApiBaseUrl, updatePassword } from "../../Utils/Constants";
import { toast } from "react-toastify";

export const hitUpdatePasswordForgotCodeApi = createAsyncThunk(
  "hitUpdatePasswordForgotCodeApi",
  async (payload) => {
    try {   
      const url = ApiBaseUrl + updatePassword;
      const response = await axios.put(url, payload);
      return response.data;
    } catch (error) {
      toast.error(error.response.data.message);
      throw error.response.data;
    }
  }
);

const VerifyForgotPasswordSlice = createSlice({
  name: "updatePasswordForgotReducer",
  initialState: {
    isLoading: false,
    data: null,
  },
  reducers: {
    clearVerifyForgotPasswordData: (state) => {
      state.data = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(hitUpdatePasswordForgotCodeApi.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(hitUpdatePasswordForgotCodeApi.fulfilled, (state, action) => {
        state.isLoading = false;
        state.data = action.payload;
      })
      .addCase(hitUpdatePasswordForgotCodeApi.rejected, (state) => {
        state.isError = false;
      });
  },
});

export const { clearVerifyForgotPasswordData } = VerifyForgotPasswordSlice.actions;
export default VerifyForgotPasswordSlice.reducer;